<template>
  <div class="topic-detail">
    <div v-wechat-title="($route.meta.title = docTitle)"></div>
    <div>
      <div class="topic-detail-top" v-if="supplydetail">
        <div class="topic-detail-top-avatarUrl">
          <img
            v-if="supplydetail.publisher&&supplydetail.publisher.avatarUrl"
            :src="supplydetail.publisher.avatarUrl"
            alt
            v-load="'oPicXS'"
            class="avatarUrl"
          />
           <span class="flag-icon my-flag-icon" v-else-if="supplydetail.member" :class="'flag-icon-'+supplydetail.member.flagStyle"></span>
          <img src="@/assets/img/empty.png" class="avatarUrl" v-else />
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 85%;
              height: 0.7rem;
            "
          >
            <div>
              <template v-if="supplydetail.member&&supplydetail.member.inMember&&supplydetail.member.inMember.companyUsers">
                <span class="span1" v-if="supplydetail.member.inMember.companyUsers.linkNameEn">
                {{ supplydetail.member.inMember.companyUsers.linkNameEn||'' }}
                <span
                  style="
                    color: #666;
                    font-size: 0.2rem;
                    padding-left: 0.12rem;
                    line-height: 0.26rem;
                    font-weight: normal;
                  "
                  v-if="supplydetail.member.jobTitleEn"
                  >{{ supplydetail.member.jobTitleEn }}</span
                >
                </span>
                <span class="span2" v-if="supplydetail.publisherType != 1">{{
                  supplydetail.member.inMember.companyUsers.company.nameEn||''
                }}</span>
                <span class="span2" v-else-if="boothHallEn"
                  ><i class="iconfont icon-dizhi" style="color: #fe781d"></i>
                  <span>{{ boothHallEn }}</span>
                </span>
                <span class="span2" v-else>{{
                  supplydetail.publisher?supplydetail.publisher.compNameEn:''
                }}</span>
              </template>
              <template v-else>
                <span class="span1" v-if="supplydetail.publisher&&supplydetail.publisher.publisherName">
                {{ supplydetail.publisherType?supplydetail.publisher.compNameEn:supplydetail.publisher.publisherName }}
                <span
                  style="
                    color: #666;
                    font-size: 0.2rem;
                    padding-left: 0.12rem;
                    line-height: 0.26rem;
                    font-weight: normal;
                  "
                  v-if="supplydetail.publisher.jobTitle"
                  >{{ supplydetail.publisher.jobTitle }}</span
                >
                </span>
                <span class="span2" v-if="supplydetail.publisherType != 1">{{
                  supplydetail.publisher?supplydetail.publisher.compNameEn:''
                }}</span>
                <span class="span2" v-else-if="boothHallEn"
                  ><i class="iconfont icon-dizhi" style="color: #fe781d"></i>
                  <span>{{ boothHallEn }}</span>
                </span>
                <span class="span2" v-else>{{
                  supplydetail.publisher?supplydetail.publisher.compNameEn:''
                }}</span>
              </template>
            </div>
            <div
              class="shoucang"
              v-if="
                userInfo&&supplydetail.memberId != userInfo.id && !supplydetail.isFollow
              "
              @click="likeClick(supplydetail.id)"
            >
              Follow
            </div>
            <div
              class="shoucang s-shoucang"
              v-if="
                supplydetail.memberId != userInfo.id && supplydetail.isFollow
              "
              @click="cancelLike(supplydetail.id)"
            >
              Unfollow
            </div>
          </div>
        </div>
        <p v-html="supplydetail.content"></p>
        <div class="topic-detail-top-img" v-if="supplydetail.imgUrls">
          <template v-for="(imgList, index) in supplydetail.imgUrls">
            <img
              :src="imgList"
              :key="index"
              v-load="'oPic'"
              preview="1"
               
              :large="imgList"
            />
          </template>
        </div>
        <div class="topic_video" v-else-if="supplydetail.videos&&supplydetail.videos[0].url">
          <videoPlayer :cover="supplydetail.videos[0].cover" :url="supplydetail.videos[0].url" ></videoPlayer>
        </div>
        <div class="topic-detail-top-read">
          <i class="iconfont icon-guankan2"></i>
          <span class="number">{{ supplydetail.viewCount }}</span>
          <i class="iconfont icon-xunpan"></i>
          <span class="number">{{ supplydetail.commentCount }}</span>
          <span class="time">{{ supplydetail.createAt }}</span>
        </div>
        
      </div>
      <div class="info_wrap" v-if="supplydetail&&supplydetail.publisher">
        <div class="type_gy" v-if="supplydetail.type.indexOf('Supply')!=-1">
          <div>
            <p>Phone：{{supplydetail.publisher.phoneNumber}}</p>
            <p>E-mail：{{supplydetail.publisher.email}}</p>
          </div>
        </div>
        <div class="type_cg" v-else>
          <div v-if="userRole&&userRole=='EXHIBITOR'">
            <div>
              <p>Phone：{{supplydetail.publisher.phoneNumber}}</p>
              <p>E-mail：{{supplydetail.publisher.email}}</p>
            </div>
          </div>
          <div class="no_reg" v-else>
            <p>Only exhibitors can view contact information</p>
            <!-- <span @click="LinkToReg" class="go_reg">Register now</span> -->
          </div>
        </div>
      </div>
      <!--话题列表-->
      <div style="padding-bottom: 1.68rem" v-if="dataList.length">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="It's the end"
          @load="loadMore"
        >
          <div
            class="topic-detail-list"
            v-for="(item2, index2) in dataList"
            :key="index2"
            v-if="item2.publisher"
          >
            <div class="topic-detail-top-avatarUrl">
              <img
                v-if="item2.publisher&&item2.publisher.avatarUrl"
                :src="item2.publisher.avatarUrl"
                alt
                class="avatarUrl"
                v-load="'oPicXS'"
              />
                <span class="flag-icon my-flag-icon" v-else-if="item2.member" :class="'flag-icon-'+item2.member.flagStyle"></span>
              <img src="@/assets/img/empty.png" class="avatarUrl" v-else />
              <div v-if="item2.member&&item2.member.inMember&&item2.member.inMember.companyUsers">
                <div style="display: flex; justify-content: space-between">
                  <span class="span1" style="display: inline-block">
                    {{ item2.member.inMember.companyUsers.linkNameEn || "" }}
                    <span
                      style="
                        color: #666;
                        font-size: 0.2rem;
                        padding-left: 0.12rem;
                        line-height: 0.26rem;
                        font-weight: normal;
                      "
                    >
                      {{item2.member.jobTitleEn }}</span
                    >
                  </span>
                  <span
                    style="
                      color: #666;
                      position: absolute;
                      right: 0.24rem;
                      font-size: 0.22rem;
                    "
                    >{{ item2.createAt }}</span
                  >
                </div>
                <span class="span2">{{ item2.member.inMember.companyUsers.company.nameEn||'' }}</span>
              </div>
              <div v-else>
                <div style="display: flex; justify-content: space-between">
                  <span class="span1" style="display: inline-block">
                    {{ item2.publisher.publisherName || "" }}
                    <span
                      style="
                        color: #666;
                        font-size: 0.2rem;
                        padding-left: 0.12rem;
                        line-height: 0.26rem;
                        font-weight: normal;
                      "
                    >
                      {{ item2.publisher.jobTitle }}</span
                    >
                  </span>
                  <span
                    style="
                      color: #666;
                      position: absolute;
                      right: 0.24rem;
                      font-size: 0.22rem;
                    "
                    >{{ item2.createAt }}</span
                  >
                </div>
                <span class="span2">{{ item2.publisher.compNameEn }}</span>
              </div>
            </div>
            <p style="margin: 0.2rem 0 0">{{ item2.content }}</p>
            <!-- <div class="reply" >
                <div class="reply-list" v-for="(item,index) in item2.imgUrls" :key="index" >
                  <span class="reply-span1">{{item.userInfo.name}}</span>
                  <span class="reply-span2">：{{item.content}}</span>
                </div>
            </div>-->
          </div>
          <div slot="loading" class="f-tac loading">
            <img src="@assets/img/new/icon-loading.png" />
            loading...
          </div>
          <div slot="finished" class="f-tac loading">It's the end~</div>
        </van-list>
      </div>
      <div class="f-tac" style="line-height: 80px" v-else>No data！</div>
      <div class="topic-detail-bottom">
        <div class="topic-detail-bottom-input" :class="demandcomment?'send_input':''">
          <input
            type="text"
            placeholder="Please add content~"
            :adjust-position="false"
            cursor-spacing="13"
            v-model="demandcomment"
            @focus="inputFocus"
            ref="input"
            maxlength="500"
            @keyup.13="send()"
          />
        </div>
        <div class="send_wrap" @click="send" v-if="demandcomment">发布</div>
        <!-- <div class="topic-detail-bottom-share" @click="$refs.shareModel.open()">
          <i class="icon iconfont icon-fenxiang2 fenxiang"></i>
          <span>分享</span>
        </div> -->
      </div>
    </div>
    <!-- <liveShare ref="liveShare"></liveShare> -->
    <shareModel ref="shareModel"></shareModel>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import shareModel from "@/components/shareModel";
import videoPlayer from "./component/videoPlayer";
// import liveShare from "@/components/live-share";
import gql from "graphql-tag";
export default {
  data() {
    return {
      supplydetail: "", //供需详情
      demandcomment: "", //供需留言,
      supplyReplyList: [], //供需评论列表
      loading: false, //展商加载状态
      finished: false, //加载是否完成状态
      pageSize: 10,
      pageIndex: 1,
      dataList: [], //供需评论回复
      querySupplyDemandComment: {},
      boothHallEn: "",
      docTitle: "",
      coordinate: "", //展商坐标
    };
  },
  components: {
    shareModel,
    videoPlayer,
    // liveShare
  },

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionInfo: "getExhibitionInfo",
      exhibitionId: "getExhibitionId",
      userRole:'getUserRole'
    }),
    DemandId() {
      return this.$route.params.id;
    },
    SupplyGql() {
      if(this.userInfo){
      return gql`query($id: String!){
        supplyDemandQuery{
            get(id:$id){
                createAt
                auditState
                commentCount
                isFollow(memberId: "${this.userInfo.id}")
                content
                productName
                type
                exhibitionId
                followCount
                id
                imgUrls
                videos
                likeCount
                publisher{
                  avatarUrl
                  compName
                  compNameEn
                  publisherName
                  publishId
                  jobTitle
                  phoneNumber
                  email
                }
                memberId
                member{
                  email
                  phone 
                  flagStyle
                  jobTitleEn
                  inMember(exhibitionId:"${this.exhibitionId}"){
                    companyUsers{
                      linkNameEn
                      company{
                        nameEn
                      }
                    }
                  }
                }
                originName
                publisherType
                shareCount
                userCount
                viewCount
            }
        }
      }`;
      }
      else{
      return gql`query($id: String!){
        supplyDemandQuery{
            get(id:$id){
                createAt
                auditState
                commentCount
                content
                productName
                type
                exhibitionId
                followCount
                id
                imgUrls
                videos
                likeCount
                member{
                  flagStyle
                  jobTitleEn
                  inMember(exhibitionId:"${this.exhibitionId}"){
                    companyUsers{
                      linkNameEn
                      company{
                        nameEn
                      }
                    }
                  }
                }
                publisher{
                  avatarUrl
                  compName
                  compNameEn
                  publisherName
                  publishId
                  jobTitle
                  phoneNumber
                  email
                }
                memberId
                originName
                publisherType
                shareCount
                userCount
                viewCount
            }
        }
      }`;
      }

    },
    DemandGql() {
      return gql`
        query querySupplyDemandComment($query: QueryInput!) {
          querySupplyDemandComment(query: $query) {
            hasNextPage
            hasPreviousPage
            items {
              content
              createAt
              id
              publisher {
                avatarUrl
                compName
                publisherName
                publishId
                jobTitle
              }
              memberId
              parentId
              replyCount
              supplyDemandId
              userInfo
              member{
                flagStyle
                jobTitleEn
                inMember(exhibitionId:"${this.exhibitionId}"){
                  companyUsers{
                    linkNameEn
                    company{
                      nameEn
                    }
                  }
                }
              }
            }
            pageIndex
            pageSize
            totalCount
            totalPages

          }
        }
      `;
    },
  },
  created() {
    this.$Myapollo.addExhibitionView();
    this.init();
  },
  mounted() {
    //图片查看器打开后，打印本次查看器的实例（事件、方法、属性的示例）
    this.$preview.on("imageLoadComplete", (e, item) => {});
  },
  methods: {
    ...mapActions({
      followerSupply: "follower/followerSupply",
      delFollowerSupply: "follower/delFollowerSupply",
      // getSupplyDemandDetial:'topicSupply/getSupplyDemand',
      addSupplyDemandView: "company/Productviewer",
      addSupplydemandcomment: "topicSupply/addSupplydemandcomment",
      shareToWechat: "wxShare/shareToWechat",
      LinkToError: "linkTo/LinkToError",
      graphqlPost: "en/graphqlPostByZXS",
      LinkToReg:"linkTo/LinkToReg"
    }),
    async init() {
      console.log(this.exhibitionId, "exhibitionInfo");

      let user = {
        name: this.userInfo.name,
        nickName: this.userInfo.nickName,
        avatarUrl: this.userInfo.avatarUrl,
        jobTitle: this.userInfo.jobTitle,
      };
      this.getSupplyDemandDetial();
      this.getDemandList();
      let opt = {
        exhibitionId: this.exhibitionId,
        target: "theme",
        targetId: this.DemandId,
        userId: this.userInfo.id,
      };
      let res = await this.addSupplyDemandView(opt);
    },
    loadMore() {
      console.log(this.finished, "this.finishedthis.finishedthis.finished");
      if (this.finished) return;
      this.pageIndex += 1;
      console.log(this.pageIndex, "当前加载的页面");
      this.getDemandList();
    },
    getSupplyDemandDetial() {
      return new Promise((resolve, reject) => {
        this.$apollo.addSmartQuery("supplyDemandQuery", {
          query: this.SupplyGql,
          variables: {
            id: this.DemandId,
          },
          fetchPolicy: "network-only", // 清除缓存的数据，重新获取服务器数据
          result(res) {
            let data = JSON.parse(JSON.stringify(res.data.supplyDemandQuery.get));
            if (!data) {
              this.LinkToError();
              return;
            }
            if (data.imgUrls) {
              data.imgUrls = data.imgUrls.split(";");
            }
            if(data.videos){
              data.videos=JSON.parse(data.videos);
            }
            if(data.content){
              data.content=data.content.split("\n").join("<br>");
            }
            this.supplydetail = data;
            console.log(this.supplydetail, "this.supplydetail");
            let desc=``;
            if(this.supplydetail.member && this.supplydetail.member.inMember && this.supplydetail.member.inMember.companyUsers&&this.supplydetail.member.inMember.companyUsers.linkNameEn){
              desc=this.supplydetail.member.inMember.companyUsers.linkNameEn+'：';
            }else if(this.supplydetail.publisher){
              desc=this.supplydetail.publisherType?this.supplydetail.publisher.compNameEn:this.supplydetail.publisher.publisherName+'：';
            }
            desc+=`#${this.supplydetail.type}#${this.supplydetail.productName}`
            // 分享的配置
            const opt = {
              title: `Recommend a supply and demand information to you`,
              isNeed:true,
              desc: desc,
              link: window.location.href,
              imgUrl: this.supplydetail.imgUrls
                ? this.supplydetail.imgUrls[0]
                : (this.supplydetail.publisher?this.supplydetail.publisher.avatarUrl:''),
            };
            this.shareToWechat(opt);
            // this.$nextTick(() => {
            //   this.$refs.liveShare.shareTo(opt);
            // });
            this.$previewRefresh();
            // this.docTitle = `${this.supplydetail.publisher.publisherName}的供需`;
            this.docTitle = this.exhibitionInfo.nameEn;
            //获取展商详情
            if (this.supplydetail.publisherType == 1) {
              this.getInfo();
              console.log();
            }
          },
          error(error) {
            console.error(error, "error错误处理");
          },
        });
      });
    },
    getDemandList() {
      // 获取评论列表
      let where = {
        Equal: {
          n: "supplyDemandId",
          v: this.DemandId,
        },
      };
      let order = [
        {
          n: "createAt",
          v: 0,
        },
      ];
      return new Promise((resolve, reject) => {
        this.$apollo.addSmartQuery("querySupplyDemandComment", {
          query: this.DemandGql,
          variables: {
            query: {
              page: this.pageIndex,
              size: this.pageSize,
              where: JSON.stringify(where),
              order: JSON.stringify(order),
            },
          },
          fetchPolicy: "network-only", // 清除缓存的数据，重新获取服务器数据
          result(res) {
            let data = JSON.parse(JSON.stringify(res));
            if (data && data.data.querySupplyDemandComment) {
              let currentList = data.data.querySupplyDemandComment.items;
              currentList.map((c) => {
                if (c.imgUrls) {
                  c.imgUrls = c.imgUrls.split(";");
                } else {
                  c.imgUrls = [];
                }
              });
              if (this.pageIndex == 1) {
                this.dataList = currentList;
              } else {
                this.dataList = [...this.dataList, ...currentList];
              }
              this.loading = false;
              if (!data.data.querySupplyDemandComment.hasNextPage) {
                this.finished = true;
                console.log(this.finished, "数据请求完毕");
              }
            }
            console.log(this.dataList,'dataList')
          },
          error(error) {
            console.error(error, "error错误处理");
          },
        });
      });
    },
    //获取展商信息
    async getInfo() {
      // console.log('调用getInfo');
      let query = `
        {
          exhibitorQuery{
            get(id:"${this.supplydetail.publisher.publishId}")
              {
                boothHall
                boothHallEn
                }
            }
        }`;
      let opt = {
        query: query,
      };
      let data = await this.graphqlPost(opt);
      console.log(data,'datatatatat,获取展商信息');
      this.boothHallEn = data.data.exhibitorQuery.get.boothHallEn;
    },
    //关注
    async likeClick(id) {
      if(this.isLoading){
        return 
      }
      this.isLoading=true;
      let user = {
        name: this.userInfo.name,
        nickName: this.userInfo.nickName,
        avatarUrl: this.userInfo.avatarUrl,
        jobTitle: this.userInfo.jobTitle,
      };
      let opt = {
        supplyDemandId: id,
        memberId: this.userInfo.id,
        userInfo: JSON.stringify(user),
      };
      let res = await this.followerSupply(opt);
      this.isLoading=false;
      if (res.result) {
        this.$toast.success("Follow ");
        this.supplydetail.isFollow = true;
      } else {
        this.$toast.fail("Follow fail");
      }
    },
    //取消关注
    async cancelLike(id) {
      let opt = {
        DemandId: id,
        memberId: this.userInfo.id,
      };
      console.log(opt, "opt");
      let res = await this.delFollowerSupply(opt);
      if (res.result) {
        this.$toast.success("Remove Follow ");
        this.supplydetail.isFollow = false;
      } else {
        this.$toast.fail("Remove failed ");
      }
    },
    async send() {
      if (this.userInfo.inMember.userRole.toUpperCase() == "VISITOR") {
        this.$Myapollo.unverifiedDialog(this);
        return;
      }
      if (!this.demandcomment.trim()) return;
      let user = {
        name: this.userInfo.name,
        nickName: this.userInfo.nickName,
        avatarUrl: this.userInfo.avatarUrl,
        jobTitle: this.userInfo.jobTitle,
      };
      let opt = {
        supplyDemandId: this.DemandId,
        memberId: this.userInfo.id,
        publisherType:0,
        publishId:this.userInfo.id,
        userInfo: JSON.stringify(user),
        content: this.demandcomment,
      };
      let res = await this.addSupplydemandcomment(opt);
      if (res.result) {
        this.$toast.success("Comment successful");
        this.demandcomment = "";
        this.pageIndex = 1;
        this.dataList = [];
        this.getDemandList();
        this.supplydetail.commentCount += 1;
      } else {
        this.$toast.fail(res.message);
      }
    },
    //
    inputFocus() {
      console.log(this.userInfo);
      if(!this.userInfo){
        this.$refs.input.blur();
         this.$Myapollo.NoUserInfo(this);
         return
      } else if (!this.userInfo.email) {
        this.$refs.input.blur();
        this.$Myapollo.unverifiedDialog(this,true);
        return;
      }else if(this.userInfo&&this.userInfo.inMember.isBlacklist){
        this.$refs.input.blur();
        this.$toast.fail('You do not have access');
        return 
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.topic-detail {
  &-top {
    padding: 0.3rem 0.24rem;
    background-color: #fff;
    border-bottom: 10px solid #f2f2f2;
    &-avatarUrl {
      display: flex;
      width: 100%;
      align-items: center;
    }
    &-img {
      display: flex;
      img {
        width: 1.1rem;
        height: 1.1rem;
        margin-right: 0.1rem;
        background: #333;
      }
    }
    &-tips {
      margin-top: 0.2rem;
      span {
        padding: 0.06rem 0.18rem 0.06rem 0.18rem;
        font-size: 0.22rem;
        color: #ff5500;
        background-color: #ffddcc;
        border-radius: 0.16rem;
        margin-right: 0.16rem;
      }
    }
    &-read {
      margin-top: 0.3rem;
      position: relative;
      display: flex;
      align-items: center;
      .number {
        margin-right: 0.05rem;
        display: inline-block;
        font-size: 0.22rem;
        color: #666;
        margin-right: 0.2rem;
      }
      .text {
        margin-right: 0.3rem;
        display: inline-block;
        font-size: 0.22rem;
        color: #666;
      }
      .time {
        font-size: 0.22rem;
        color: #666;
        position: absolute;
        right: 0;
      }
    }
  }
  &-list {
    padding: 0.3rem 0.24rem;
    background-color: #fff;
    position: relative;
    border-bottom: 1px solid #f2f2f2;
  }
  .info_wrap{
    padding: 0.2rem 0.24rem;
    background-color: #fff;
    border-bottom: 10px solid #f2f2f2;
    p{
      margin: 0.1rem 0;
    }
    .type_cg{
      .no_reg{
        text-align: center;
        .go_reg{
          color: #1890ff;
          margin-bottom: 0.1rem;
          display: inline-block;
        }
      }
    }
  }
  .avatarUrl {
    width: 0.7rem;
    height: 0.7rem;
    border-radius: 50%;
    background-color: #616777;
    margin-right: 0.16rem;
  }
  .topic_video{
    width: 100%;
    height:4.2rem;
    margin-top: 0.15rem;
  }
  .span1 {
    font-size: 0.26rem;
    font-weight: bold;
    color: #333;
    display: block;
  }
  .span2 {
    font-size: 0.22rem;
    color: #666;
    display: block;
    margin-top: 0.05rem;
  }
  p {
    margin: 0.2rem 0;
    font-size: 0.26rem;
    line-height: 0.4rem;
    color: #333;
  }

  .dianzan {
    display: inline-block;
    font-size: 0.34rem;
    transform: scale(2);
    margin-bottom: 0.08rem;
  }
  .fenxiang {
    display: inline-block;
    font-size: 0.34rem;
    transform: scale(2);
    margin-bottom: 0.08rem;
  }
  .shoucang {
    height: 0.48rem;
    width: 1.1rem;
    border-radius: 0.26rem;
    background: #ff5c00;
    color: #fff;
    font-size: 0.24rem;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 1.1rem;
    // height: .5rem;
    // background-color: #f85b0f;
    // border-radius: .24rem;
    // text-align: center;
    // span{
    //   color: #fff;
    //   line-height: .48rem;
    //   font-size: .24rem;
    // }
  }
  .s-shoucang {
    border: solid 1px #ff5c00;
    color: #ff5c00;
    background: transparent;
    // width: 1.1rem;
    // height: .5rem;
    // background-color: #fff;
    // border: 1px solid #f85b0f;
    // border-radius: .24rem;
    // text-align: center;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // span{
    //   color: #f85b0f;
    //   font-size: .24rem;
    // }
  }
  .topic-detail-bottom {
    position: fixed;
    bottom: 0;
    display: flex;
    align-items: center;
    height: 1rem;
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2);
    &-input {
      margin: 0.17rem 0.24rem;
      width: 100%;
      height: 0.64rem;
      background-color: #f2f2f2;
      border-radius: 0.32rem;
      position: relative;
      display: flex;
      align-items: center;
      input {
        margin-left: 0.26rem;
        border: none;
        background-color: #f2f2f2;
        width: 90%;
      }
      &.send_input{
        width: 5.7rem;
      }
    }
    &-share {
      text-align: center;
      margin: 0.2rem 0 0.17rem 0.22rem;
      color: #666;
      span {
        display: block;
        color: #666;
        font-size: 0.22rem;
      }
    }
    .send_wrap{
      height: 32px;
      background:  #1890ff;
      padding: 0 0.3rem;
      color: #fff;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }
  }
  .pb {
    padding-bottom: 0.68rem;
  }
  .reply {
    background-color: #f7f7f7;
    border-radius: 0.1rem;
    &-list {
      padding: 0.1rem;
      .reply-span1 {
        color: #f85b0f;
        font-size: 0.26rem;
      }
      .reply-span2 {
        color: #333;
        font-size: 0.26rem;
      }
    }
  }
}
button {
  padding: 0;
  line-height: 1;
  background-color: #fff;
}
button:after {
  border: none;
}
// /deep/ .dialog_unauth{
//   .van-popup{
//     border-radius: 10px;
//     width: 560px;
//     box-sizing: border-box;
//     // .van-dialog__header{
//     //   padding-top: 50px;
//     //   font-size: 36px;
//     //   font-weight: bold;
//     //   color: #333;
//     // }
//     .van-dialog__message{
//       font-size: 30px;
//       color: #666;
//       line-height: 50px;
//     }
//     .van-hairline--top{
//       &::after{
//         border-color:#d2d3d5;
//         border-top-width: 2px;
//       }
//     }
//     .van-dialog__footer{
//       .van-hairline--right{
//         &::after{
//           border-color: #d2d3d5;
//           border-right-width: 2px;

//         }
//       }
//       .van-dialog__button{
//         .dialog-index--van-dialog__confirm{
//           color: #f85b0f!important;
//         }
//       }
//     }
//   }
// }
.f-tac {
  text-align: center;
  color: #969799;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>

